import SelectionCardClassicImpl from './selection-card-classic.js';
import MojitoCore from 'mojito/core';
import { propTypes, defaultProps } from 'modules/event-cards/selection/prop-types.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Classic design style selection card.
 *
 * @function SelectionCardClassic
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Selection.Classic
 */

/**
 * Classic selection card prop types.
 *
 * @extends Mojito.Modules.EventCards.Selection.SelectionCardPropTypes
 *
 * @memberof Mojito.Modules.EventCards.Selection.Classic.view
 */

export default UIView('SelectionCardClassic', SelectionCardClassicImpl, propTypes, defaultProps);
